module.exports = __webpack_public_path__ + "img/WordBuildingPortalEntrancex.6ed6dd12.png";